import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../../reducers";
import { CommonService } from "../../../../services/common.service";
import {
  Combo2Service,
  ComboService,
  ExcelService,
  ReportService,
} from "../../../../services/index";
import { PurchaseOrderService } from "../../../../services/purchaseorder.service";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./coreStatusReport.html",
})
export class coreStatusReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  typeList = ["Wholesale", "Retail", "Estimate"];
  gridOptions: any;
  designnoList = [];
  dataList = [];
  coreGang = ["CORE", "GANG", "PLAIN", "ALL"];
  total = {
    f36: 0,
    f38: 0,
    f40: 0,
    f42: 0,
    f44: 0,
    f46: 0,
    ftot: 0,
    h36: 0,
    h38: 0,
    h40: 0,
    h42: 0,
    h44: 0,
    h46: 0,
    htot: 0,
    total: 0,
    f36_1: 0,
    f38_1: 0,
    f40_1: 0,
    f42_1: 0,
    f44_1: 0,
    f46_1: 0,
    ftot_1: 0,
    h36_1: 0,
    h38_1: 0,
    h40_1: 0,
    h42_1: 0,
    h44_1: 0,
    h46_1: 0,
    htot_1: 0,
    total_1: 0,
  };
  qualityList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  brandList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  groupbyList = ["DESIGN NO", "WO NO"];
  filter: any = {
    design_no: "",
    core_designno: "",
    from_date: "",
    to_date: "",
    party_id: "",
    type: "",
    core_gang: "ALL",
    groupby: "designStock",
    finyear: "",
  };
  minStock = {
    f36: 0,
    f38: 0,
    f40: 0,
    f42: 0,
    f44: 0,
    f46: 0,
    ftot: 0,
    h36: 0,
    h38: 0,
    h40: 0,
    h42: 0,
    h44: 0,
    h46: 0,
    htot: 0,
    total: 0,
  };
  wareStock = {
    f36: 0,
    f38: 0,
    f40: 0,
    f42: 0,
    f44: 0,
    f46: 0,
    ftot: 0,
    h36: 0,
    h38: 0,
    h40: 0,
    h42: 0,
    h44: 0,
    h46: 0,
    htot: 0,
    total: 0,
  };
  woStock = {
    f36: 0,
    f38: 0,
    f40: 0,
    f42: 0,
    f44: 0,
    f46: 0,
    ftot: 0,
    h36: 0,
    h38: 0,
    h40: 0,
    h42: 0,
    h44: 0,
    h46: 0,
    htot: 0,
    total: 0,
  };
  fabricStock = {
    f36: 0,
    f38: 0,
    f40: 0,
    f42: 0,
    f44: 0,
    f46: 0,
    ftot: 0,
    h36: 0,
    h38: 0,
    h40: 0,
    h42: 0,
    h44: 0,
    h46: 0,
    htot: 0,
    total: 0,
  };
  lrStock = {};
  poStock = {};
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "WorkOrder Report",
    columns: [],
    rows: [],
  };

  partyList = [];

  // @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
  // @ViewChild('nameTemplate') nameTemplate: TemplateRef<any>;
  // @ViewChild('addrTemplate') addrTemplate: TemplateRef<any>;
  //   @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  //   @ViewChild('partyDataTable') partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private commonserv: CommonService,
    private poservice: PurchaseOrderService,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public toasterService: ToasterService,
    public comboservice: ComboService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.widthlist();
    this.getCoreDesignNoList();
    //  this.brandlist();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        toggle: true,
        cellClass: "text-center",
        headerClass: "text-center",
      },
      {
        name: "WO.NO",
        prop: "wo_no",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
      },
      {
        name: "Fabric Design",
        prop: "fab_design",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
      },
      {
        name: "Shirt design",
        prop: "shirtdno",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "Width",
        prop: "width",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Brand",
        prop: "brand",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "F/S",
        prop: "ftot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "H/S",
        prop: "htot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "GR.Tot",
        prop: "gr_tot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }
  openScreen(event) {
    $("#shadeContainer").css("display", "none");
    this.filter.groupby = "IndStock";
    let params = {
      design_no: event.row.core_designno,
      shade: event.row.shade,
    };
    this.reportService.openCore(params).then((res: any) => {
      let param = {
        f36: 0,
        f38: 0,
        f40: 0,
        f42: 0,
        f44: 0,
        f46: 0,
        ftot: 0,
        h36: 0,
        h38: 0,
        h40: 0,
        h42: 0,
        h44: 0,
        h46: 0,
        htot: 0,
        total: 0,
        design_no: "",
        shirt_design_no: "",
        shade: 0,
      };
      this.minStock = res.minStock;
      this.wareStock = res.wareStock;
      this.woStock = res.woStock;
      if (res.woStock.shirt_design_no == null) {
        this.woStock = param;
      }
      if (res.minStock.shirt_design_no == null) {
        this.minStock = param;
      }
      if (res.wareStock.design_no == null) {
        this.wareStock = param;
      }
      this.total.f36 = Number(this.minStock.f36) - Number(this.wareStock.f36);
      this.total.f38 = Number(this.minStock.f38) - Number(this.wareStock.f38);
      this.total.f40 = Number(this.minStock.f40) - Number(this.wareStock.f40);
      this.total.f42 = Number(this.minStock.f42) - Number(this.wareStock.f42);
      this.total.f44 = Number(this.minStock.f44) - Number(this.wareStock.f44);
      this.total.f46 = Number(this.minStock.f46) - Number(this.wareStock.f46);
      this.total.ftot =
        Number(this.minStock.ftot) - Number(this.wareStock.ftot);
      this.total.h36 = Number(this.minStock.h36) - Number(this.wareStock.h36);
      this.total.h38 = Number(this.minStock.h38) - Number(this.wareStock.h38);
      this.total.h40 = Number(this.minStock.h40) - Number(this.wareStock.h40);
      this.total.h42 = Number(this.minStock.h42) - Number(this.wareStock.h42);
      this.total.h44 = Number(this.minStock.h44) - Number(this.wareStock.h44);
      this.total.h46 = Number(this.minStock.h46) - Number(this.wareStock.h46);
      this.total.htot =
        Number(this.minStock.htot) - Number(this.wareStock.htot);
      this.total.f36_1 = Number(this.woStock.f36);
      this.total.f38_1 = Number(this.woStock.f38);
      this.total.f40_1 = Number(this.woStock.f40);
      this.total.f42_1 = Number(this.woStock.f42);
      this.total.f44_1 = Number(this.woStock.f44);
      this.total.f46_1 = Number(this.woStock.f46);
      this.total.ftot_1 = Number(this.woStock.ftot);
      this.total.h36_1 = Number(this.woStock.h36);
      this.total.h38_1 = Number(this.woStock.h38);
      this.total.h40_1 = Number(this.woStock.h40);
      this.total.h42_1 = Number(this.woStock.h42);
      this.total.h44_1 = Number(this.woStock.h44);
      this.total.h46_1 = Number(this.woStock.h46);
      this.total.htot_1 = Number(this.woStock.htot);

      this.total.total =
        Number(this.minStock.total) - Number(this.wareStock.total);
      this.total.total_1 = Number(this.woStock.total);
      this.exceldata = this.getData("columns name", res.data);
    });
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }
  brandlist() {
    let data = this.commonserv.itemMaster();
    let brand = data.brand;
    this.brandList = brand;
    let style = data.style;
  }
  getCoreDesignNoList() {
    let params = {};
    this.comboservice.getCoreDesignCombo(params).then((res: any) => {
      this.designnoList = res;
    });
  }

  onCellClick(event) {
    this.filter.core_designno = event.row.core_designno;
    if (this.filter.groupby == "shadeStock") {
      this.filter.groupby = "IndStock";
    }
    if (this.filter.groupby == "designStock") {
      this.filter.groupby = "shadeStock";
    }

    this.getReport();
  }
  onCellClick1(event) {
    this.filter.core_designno = event.row.core_designno;
    this.filter.groupby = "shadeStock";

    this.getReport();
  }
  goToShade(event) {
    this.filter.groupby = "shadeStock";
    $("#shadeContainer").css("display", "block");
    //  this.getReport()
  }
  onbackbutton() {
    this.filter.groupby = "designStock";
    this.filter.party_id = "";
    this.filter.design_no = "";
    this.filter.core_designno = "";
    this.getReport();
  }

  applyFilter(): void {
    this.filter.party_id = "";
    this.filter.groupby = "designStock";
    this.filter.invoiceno = "";
    this.filter.core_designno = "";
    this.filter.shade = "";
    this.getReport();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      var temp = ["Core", "All"];
      that.finyearList.concat(temp);
      that.filter.finyear = res.data[0].finyear;
      that.finyearCtrl.setValue(res.data[0].fin_id);
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  getReport(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .coreStatusReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/coreGangReport/coreStatusReport.ts